import { View, ViewProps } from "react-native"
import { cn } from "@src/utils"

interface TableProps extends ViewProps {
  className?: string
}

function Table({ className, ...props }: TableProps) {
  return <View className={cn("w-full caption-bottom text-sm", className)} {...props} />
}

function TableHeader({ className, ...props }: TableProps) {
  return <View className={cn("border-b border-gray-200", className)} {...props} />
}

function TableBody({ className, ...props }: TableProps) {
  return <View className={cn("", className)} {...props} />
}

function TableFooter({ className, ...props }: TableProps) {
  return <View className={cn("border-t bg-gray-100/50 font-medium", className)} {...props} />
}

interface TableRowProps extends ViewProps {
  className?: string
  onPress?: () => void
}

function TableRow({ className, ...props }: TableRowProps) {
  return <View className={cn("border-b border-gray-200 flex-row", className)} {...props} />
}

function TableHead({ className, ...props }: TableProps) {
  return <View className={cn("h-12 px-4 justify-center", className)} {...props} />
}

function TableCell({ className, ...props }: TableProps) {
  return <View className={cn("p-4 justify-center", className)} {...props} />
}

function TableCaption({ className, ...props }: TableProps) {
  return <View className={cn("mt-4 text-sm text-gray-500", className)} {...props} />
}

export { Table, TableHeader, TableBody, TableFooter, TableHead, TableRow, TableCell, TableCaption }
